import React, { useState } from 'react';
import RestUtilities from '../../services/RestUtilities';
import { Grid, TextField, Button, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isEmailInvalid, setIsEmailInvalid] = useState(false);
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(false);

  async function handleForgotPasswordClick() {
    const url = '/api/auth/ForgotPassword';
    const data = { email: email };
    setDisabled(true);
    await RestUtilities.post(url, data)
      .then(() => setError(false))
      .catch(() => setError(true));
  }

  return (
    <form noValidate>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <TextField
            variant='outlined'
            value={email}
            margin='normal'
            required
            fullWidth
            id='email'
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
            onChange={(event) => {
              setIsEmailInvalid(!isEmail(event.target.value));
              setEmail(event.target.value);
            }}
            error={isEmailInvalid}
            helperText={isEmailInvalid && 'Not an email address.'}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant='contained'
            color='secondary'
            sx={{ mt: 2 }}
            onClick={() => handleForgotPasswordClick()}
            disabled={disabled || isEmailInvalid}
          >
            Reset Password
          </Button>
        </Grid>
        {disabled && !error && (
          <Grid item xs={12}>
            <Typography component='p'>
              Please check your email to continue resetting your password.
            </Typography>
          </Grid>
        )}
        {disabled && error && (
          <Grid item xs={12}>
            <Typography component='p'>Something went wrong.</Typography>
          </Grid>
        )}
      </Grid>
      <Box mt={3}>
        <Link to={'/login'}>Already have an account? Sign in</Link>
      </Box>
    </form>
  );
};

export default ForgotPassword;
